import { render } from "./FacialRecognition.vue?vue&type=template&id=218bf9e6&scoped=true"
import script from "./FacialRecognition.vue?vue&type=script&lang=js"
export * from "./FacialRecognition.vue?vue&type=script&lang=js"

import "./FacialRecognition.vue?vue&type=style&index=0&id=218bf9e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218bf9e6"]])

export default __exports__